import OnboardingSteps from "./OnboardingSteps";
import { FC, PropsWithChildren } from "react";
import { LogoWithTitle } from "~@/icons";

type OnboardingSidebarProps = {
  showSteps?: boolean;
};

const OnboardingSidebar: FC<PropsWithChildren<OnboardingSidebarProps>> = ({
  children,
  showSteps = true,
}) => {
  return (
    <div className="onboarding-sidebar">
      <div className="icon icon--has-default-size">
        <LogoWithTitle />
      </div>
      <div className="container container--is-centered container--is-v-centered container--has-text-centered">
        {children}
      </div>
      {showSteps && <OnboardingSteps />}
    </div>
  );
};

export default OnboardingSidebar;
